import { AlertTriangle } from 'lucide-react';
import { useTranslations } from 'use-intl';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useConsentContextOptional } from '@/components/providers/ConsentProvider';
import { accountLabel, renewalRequestFor, type RenewableAccount } from '@/lib/renewalRequest';

/**
 * Signing refused because a source account has no bank access of its own (FIN-968): the same
 * "Access needed" wording and Renew access action as Edit payment details and the Bank page.
 */
export function PaymentAccessNeededAlert({ accounts }: { accounts: RenewableAccount[] }) {
  const t = useTranslations('consultantPayments.access');
  const consentContext = useConsentContextOptional();
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>{t('needed')}</AlertTitle>
      <AlertDescription className="space-y-2">
        {accounts.map((account) => (
          <p key={account.id}>{t('expired', { account: accountLabel(account) })}</p>
        ))}
        {consentContext && accounts.length > 0 && (
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto p-0 font-semibold underline underline-offset-2"
            onClick={() => consentContext.setConsentRequiredError(renewalRequestFor(accounts))}
          >
            {t('renew')}
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
}
